import { GetAllContentPackageWithDiscussionStatusMeta, GetAllContentPackageWithDiscussionStatusPayload } from 'types/store/GetAllContentPackageWithDiscussionStatus';
import { createAsyncReducer } from 'utils/Redux';

import { getAllContentPackageWithDiscussionStatusActions } from '../actions';

export default createAsyncReducer<GetAllContentPackageWithDiscussionStatusMeta, GetAllContentPackageWithDiscussionStatusPayload>(getAllContentPackageWithDiscussionStatusActions);
